var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForwardCurveConstraints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5117 4.76245L14.615 12.0958H16.495L14.3917 4.76245H12.5117Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85504 4.76245L9.95838 12.0958H11.8417L9.73838 4.76245H7.85504Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.915 4.76245H17.165L19.2684 12.0958H20.915C21.2463 12.0949 21.5637 11.9629 21.798 11.7287C22.0322 11.4945 22.1642 11.177 22.165 10.8458V6.01245C22.1642 5.6812 22.0322 5.36377 21.798 5.12954C21.5637 4.89531 21.2463 4.76333 20.915 4.76245Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41504 4.76245C3.08379 4.76333 2.76636 4.89531 2.53213 5.12954C2.2979 5.36377 2.16592 5.6812 2.16504 6.01245V10.8458C2.16592 11.177 2.2979 11.4945 2.53213 11.7287C2.76636 11.9629 3.08379 12.0949 3.41504 12.0958H7.18171L5.08171 4.76245H3.41504Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74837 18.0958H6.3317V12.7625H4.66504V18.0958H4.2917C4.08718 18.0958 3.89098 18.1768 3.74605 18.3211C3.60112 18.4654 3.51925 18.6613 3.51837 18.8658V19.7625H7.51837V18.8658C7.51749 18.6618 7.43609 18.4665 7.29187 18.3223C7.14766 18.1781 6.95232 18.0967 6.74837 18.0958Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0617 18.0958H19.665V12.7625H17.9984V18.0958H17.6017C17.3978 18.0967 17.2024 18.1781 17.0582 18.3223C16.914 18.4665 16.8326 18.6618 16.8317 18.8658V19.7625H20.8317V18.8658C20.8308 18.6618 20.7494 18.4665 20.6052 18.3223C20.461 18.1781 20.2657 18.0967 20.0617 18.0958Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardCurveConstraints);
export default __webpack_public_path__ + "static/media/forward-curve-constraints.11fcd39a.svg";
export { ForwardRef as ReactComponent };